/**
 * Best-effort country/operator label resolver.
 *
 * The backend already returns a server-computed operator + countryCode for
 * verifications and opportunities — these helpers are for cases where the
 * server label is missing, e.g. legacy rows that pre-date the operator
 * column. Keep the prefix tables in sync with PhoneLookup.java.
 */

const OPERATOR_LABEL: Record<string, string> = {
  STC: 'STC',
  MOBILY: 'Mobily',
  ZAIN: 'Zain',
  ORANGE: 'Orange',
  UMNIAH: 'Umniah',
  ETISALAT: 'Etisalat',
  DU: 'du',
  VODAFONE: 'Vodafone',
  WE: 'WE',
  OTHER: 'Other',
  UNKNOWN: 'Unknown',
};

const COUNTRY_FLAG: Record<string, string> = {
  JO: '🇯🇴',
  SA: '🇸🇦',
  AE: '🇦🇪',
  EG: '🇪🇬',
  UNKNOWN: '🌐',
};

const COUNTRY_NAME: Record<string, string> = {
  JO: 'Jordan',
  SA: 'Saudi Arabia',
  AE: 'UAE',
  EG: 'Egypt',
  UNKNOWN: 'Unknown',
};

export function operatorLabel(code: string | null | undefined): string {
  if (!code) return OPERATOR_LABEL.UNKNOWN!;
  return OPERATOR_LABEL[code.toUpperCase()] ?? code;
}

export function countryLabel(code: string | null | undefined): string {
  if (!code) return COUNTRY_NAME.UNKNOWN!;
  return COUNTRY_NAME[code.toUpperCase()] ?? code;
}

export function countryFlag(code: string | null | undefined): string {
  if (!code) return COUNTRY_FLAG.UNKNOWN!;
  return COUNTRY_FLAG[code.toUpperCase()] ?? COUNTRY_FLAG.UNKNOWN!;
}
